<template>
  <div>
    <v-card class="ma-6">
      <v-card-title>
        <v-icon color="primary" class="mr-6">mdi-search-web</v-icon>
        Ad-hoc Scan
      </v-card-title>
      <v-card-text>
        <div v-if="error">
          <v-alert type="error">{{ error }}</v-alert>
        </div>
        <div v-else>
          Starting scan for CatCode: <strong>{{ catCode }}</strong>...
          <v-progress-linear indeterminate color="primary" class="my-4"></v-progress-linear>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { AdhocScansService } from '../services/api/adhocScans';
  const apiAdhocScans = new AdhocScansService();

  export default {
    data() {
      return {
        catCode: this.$route.params.catCode,
        error: null,
      };
    },

    mounted() {
      this.startScan();
    },

    methods: {
      async startScan() {
        try {
          await apiAdhocScans.startScanByCatCode(this.catCode);
          this.$router.push('/adhocScan');
        } catch (err) {
          // The scan was initiated on the backend even if the HTTP call times out or errors,
          // so navigate to the ad-hoc page to show progress.
          if (err.response && err.response.status >= 400 && err.response.status < 500) {
            this.error = err.response.data?.message || err.response.data?.Message || 'Failed to start scan for CatCode: ' + this.catCode;
          } else {
            // For timeouts or server errors, the scan may still be running - redirect to progress page.
            this.$router.push('/adhocScan');
          }
        }
      },
    },
  };
</script>
